var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.654 5c.098 0 .19.04.255.109.066.069.099.161.09.254l-.89 9.424c-.064.687-.662 1.213-1.377 1.213H4.27c-.715 0-1.313-.526-1.378-1.213l-.89-9.424L2 5.332c0-.184.156-.333.347-.332zM9.231 7.167c-.286 0-.518.224-.518.5v6c0 .276.232.5.518.5.286 0 .519-.224.519-.5v-6c0-.276-.233-.5-.519-.5zm-3.457 0c-.287 0-.519.224-.519.5v6c0 .276.232.5.519.5.286 0 .518-.224.518-.5v-6c0-.276-.232-.5-.518-.5zM9.204 0c.942 0 1.705.746 1.705 1.667V2.5c0 .092.076.167.17.167h3.24c.376 0 .681.298.681.666 0 .368-.305.667-.682.667H.682C.305 4 0 3.701 0 3.333c0-.368.305-.666.682-.666H3.92c.095 0 .17-.075.17-.167v-.833C4.09.746 4.855 0 5.796 0zm0 1.333H5.796c-.188 0-.34.15-.34.334V2.5c0 .092.076.167.17.167h3.75c.094 0 .17-.075.17-.167v-.833c0-.184-.152-.334-.34-.334z",
    transform: "translate(-1402 -1340) translate(1137 1187) translate(10 137) translate(219 14) translate(36 2)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.3be9bb54441d42cea206eb89aff2bc0d.svg";
export { ForwardRef as ReactComponent };